var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('b-container',{attrs:{"fluid":""}},[_c('Menu'),_vm._v(" "),_c('b-breadcrumb',{attrs:{"items":_vm.items}}),_c('router-view'),_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }